import { Stack, Typography } from '@mui/material';

import {
  ErrorLoadingPage,
  Loading,
  NoSearchResults,
} from '@hapvida/hapvida-core-components';

import { FinancialIncomeReportCard } from './components';
import type { FinancialIncomeReportLayoutProps } from './types';

export function FinancialIncomeReportLayout({
  data,
  isLoading,
  isError,
  onReloadClick,
}: Readonly<FinancialIncomeReportLayoutProps>) {
  if (isError) {
    return <ErrorLoadingPage onReloadClick={onReloadClick} />;
  }

  if (isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você.
          </>
        }
      />
    );
  }

  const totalIncomeReportLength = data?.extracts?.length ?? 0;

  const isEmpty = totalIncomeReportLength === 0;

  if (isEmpty) {
    return (
      <Stack paddingTop={3}>
        <NoSearchResults hideButton />
      </Stack>
    );
  }

  return (
    <Stack paddingTop={3} paddingBottom={8}>
      {data && data?.extracts?.length > 0 && (
        <>
          <Typography variant="subtitle1" fontWeight={900}>
            Demonstrativo de Declaração de Imposto de Renda
          </Typography>
          <FinancialIncomeReportCard {...data} />
        </>
      )}
    </Stack>
  );
}
